export enum VehiclesCanHistoryMessages {
  title = "vehiclesCanHistory.title",
  generalHistory = "vehiclesCanHistory.generalHistory",
  historyByEquipment = "vehiclesCanHistory.historyByEquipment",
  equipment = "vehiclesCanHistory.equipment",
  travels = "vehiclesCanHistory.travels",
  engineRuntime = "vehiclesCanHistory.engineRuntime",
  idleEngineHours = "vehiclesCanHistory.idleEngineHours",
  kmTraveled = "vehiclesCanHistory.kmTraveled",
  speedingAlerts = "vehiclesCanHistory.speedingAlerts",
  licensePlate = "vehiclesCanHistory.licensePlate",
  fuelConsumption = "vehiclesCanHistory.fuelConsumption",
  idleFuelConsumption = "vehiclesCanHistory.idleFuelConsumption",
  avgFuelConsumption = "vehiclesCanHistory.avgFuelConsumption",
  litersPerHour = "vehiclesCanHistory.litersPerHour",
  litersPerM3 = "vehiclesCanHistory.litersPerM3",
  litersPerTravel = "vehiclesCanHistory.litersPerTravel",
  idleLitersPerHour = "vehiclesCanHistory.idleLitersPerHour",
  fuelingAlerts = "vehiclesCanHistory.fuelingAlerts",
  suddenDropAlerts = "vehiclesCanHistory.suddenDropAlerts",
  highTemperatureAlerts = "vehiclesCanHistory.highTemperatureAlerts",
  vehicleType = "vehiclesCanHistory.vehicleType",
  vehicles = "vehiclesCanHistory.vehicles"
}

export type TranslationVehiclesCanHistoryMessages = {
  [key in VehiclesCanHistoryMessages]: string;
}
